import React from 'react';
import {
  Instagram,
  Facebook,
  MapPin,
  Phone,
  Mail,
  MessageCircle
} from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const websiteEnquiryLink =
    'mailto:smartdeskai24@gmail.com?subject=Website%20Package%20Enquiry';

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const navigateTo = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-zinc-950 border-t border-gray-900">
      <div className="container mx-auto px-6 py-16">

        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">

          {/* Column 1 - About Bond Boxing */}
          <div>
            <div className="text-white font-bold text-xl tracking-wider mb-4">
              BOND BOXING
            </div>

            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('philosophy')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm text-left"
                >
                  About Bond Boxing
                </button>
              </li>

              <li>
                <button
                  onClick={() => scrollToSection('philosophy')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm text-left"
                >
                  Mission & Vision
                </button>
              </li>

              <li>
                <p className="text-gray-500 text-xs leading-relaxed mt-3">
                  To develop champions through boxing, fight experiences, and
                  inclusive fitness for all, promoting discipline and community.
                </p>
              </li>
            </ul>
          </div>

          {/* Column 2 - Bond Boxing Gym */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Gym</h4>

            <p className="text-red-500 text-xs font-semibold uppercase tracking-[0.2em] mb-4">
              Train Like A Pro
            </p>

            <p className="text-gray-400 text-sm mb-3">
              Inside the Gym
            </p>

            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => navigateTo('/gym')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm text-left"
                >
                  Weekly Program
                </button>
              </li>

              <li>
                <button
                  onClick={() => navigateTo('/gym')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm text-left"
                >
                  Membership Packages
                </button>
              </li>

              <li>
                <button
                  onClick={() => navigateTo('/gym')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm text-left"
                >
                  Gym Facilities
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Bond Boxing Promotions */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Events</h4>

            <p className="text-red-500 text-xs font-semibold uppercase tracking-[0.2em] mb-4">
              This Is Boxing
            </p>

            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => navigateTo('/events')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm text-left"
                >
                  Upcoming Fight Nights
                </button>
              </li>

              <li>
                <button
                  onClick={() => navigateTo('/events')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm text-left"
                >
                  Past Fight Nights
                </button>
              </li>

              <li>
                <button
                  onClick={() => navigateTo('/events')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm text-left"
                >
                  Event Highlights
                </button>
              </li>
            </ul>
          </div>

          {/* Column 4 - 125 Club */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">125 Club</h4>

            <p className="text-red-500 text-xs font-semibold uppercase tracking-[0.2em] mb-4">
              From The Streets To The Podium
            </p>

            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => navigateTo('/amateur')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm text-left"
                >
                  The Heart of 125 Club
                </button>
              </li>

              <li>
                <button
                  onClick={() => navigateTo('/amateur')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm text-left"
                >
                  Amateur Development Program
                </button>
              </li>

              <li>
                <button
                  onClick={() => navigateTo('/amateur')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm text-left"
                >
                  Upcoming Amateur Bouts
                </button>
              </li>

              <li>
                <button
                  onClick={() => navigateTo('/amateur')}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm text-left"
                >
                  Youth Boxing Opportunities
                </button>
              </li>
            </ul>
          </div>

          {/* Column 5 - Contact & Socials */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">
              Contact & Socials
            </h4>

            <ul className="space-y-3">

              {/* Location */}
              <li className="flex items-start gap-2">
                <MapPin
                  className="text-red-500 flex-shrink-0 mt-0.5"
                  size={16}
                />

                <div>
                  <p className="text-gray-400 text-sm">Gaborone</p>
                  <p className="text-gray-400 text-sm">Botswana</p>
                </div>
              </li>

              {/* Phone */}
              <li className="flex items-center gap-2">
                <Phone
                  className="text-red-500 flex-shrink-0"
                  size={16}
                />

                <a
                  href="tel:+26771663001"
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm"
                >
                  +267 71 663 001
                </a>
              </li>

              {/* Email */}
              <li className="flex items-center gap-2">
                <Mail
                  className="text-red-500 flex-shrink-0"
                  size={16}
                />

                <a
                  href="mailto:info@bondboxing.com"
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm"
                >
                  info@bondboxing.com
                </a>
              </li>

              {/* WhatsApp */}
              <li className="flex items-center gap-2">
                <MessageCircle
                  className="text-red-500 flex-shrink-0"
                  size={16}
                />

                <a
                  href="https://wa.me/26771663001"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 text-sm"
                >
                  WhatsApp Contact
                </a>
              </li>
            </ul>

            {/* Social Media Icons */}
            <div className="mt-6">
              <div className="flex gap-3">

                <a
                  href="https://www.instagram.com/bondboxing?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-red-600 flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label="Instagram"
                >
                  <Instagram className="text-white" size={18} />
                </a>

                <a
                  href="https://www.facebook.com/BondBoxingpromotions"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-red-600 flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label="Facebook"
                >
                  <Facebook className="text-white" size={18} />
                </a>

                <a
                  href="https://wa.me/26771663001"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-red-600 flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label="WhatsApp"
                >
                  <MessageCircle className="text-white" size={18} />
                </a>

              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">

            <div className="flex flex-col items-center md:items-start gap-2">
              <p className="text-gray-500 text-sm">
                © {new Date().getFullYear()} Bond Boxing - All Rights Reserved
              </p>

              <p className="text-gray-500 text-xs">
                Powered by{' '}
                <a
                  href={websiteEnquiryLink}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-300 font-semibold"
                  aria-label="Enquire about website packages from O'Brien Intelligence"
                >
                  O’Brien Intelligence.
                </a>
              </p>
            </div>

            <p className="text-red-500 font-semibold text-sm tracking-wider">
              Train Like A Pro
            </p>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;